(() => {
  function init(root = document) {
    root.querySelectorAll('[data-mtqb-open]').forEach(button => {
      if (button.dataset.mtqbBound) return;
      button.dataset.mtqbBound = 'true';
      const dialog = document.getElementById(button.dataset.mtqbOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      button.hidden = false;
      button.addEventListener('click', () => dialog.showModal());
      dialog.addEventListener('close', () => button.focus());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
